import { useTranslation } from 'react-i18next'

import FieldsetGroup from 'src/components/shared/ui/form/fields/FieldsetGroup/FieldsetGroup'
// import TrasladoDeCopia from 'src/components/views/EscritosLexnet/components/Tramite/components/Destino/components/TrasladoDeCopia'
import OrganoDestino from 'src/components/views/EscritosLexnet/components/shared/components/OrganoDestino/OrganoDestino'

function Destino(): JSX.Element {
  const { t } = useTranslation()

  return (
    <FieldsetGroup legend={t('form.legend.destino')}>
      <OrganoDestino />
      {/* {<TrasladoDeCopia />} */}
    </FieldsetGroup>
  )
}

export default Destino
